//--- ARQUIVO NOVO E COMPLETO: CircularProgressBar.js ---
import React from 'react';

/**
 * Renderiza um gráfico de progresso circular (donut) com um texto de porcentagem no centro.
 *
 * @param {object} props
 * @param {number} props.percentage - O valor da porcentagem (ex: 75, ou 110.50).
 * @param {string} [props.colorClass="text-blue-600"] - A classe de cor do Tailwind para o anel de progresso.
 * @param {number} [props.size=100] - A largura e altura do gráfico em pixels.
 * @param {number} [props.strokeWidth=10] - A espessura do anel do gráfico.
 * @returns {JSX.Element}
 */
export const CircularProgressBar = ({ percentage, colorClass = "text-blue-600", size = 100, strokeWidth = 10 }) => {
    
    // O 'cleanPercentage' é usado APENAS para o desenho do círculo (limitado a 100%).
    const cleanPercentageForDrawing = Math.max(0, Math.min(percentage, 100));

    // Cálculos de SVG
    const center = size / 2;
    const radius = center - strokeWidth / 2;
    const circumference = 2 * Math.PI * radius;

    // Offset para o círculo (trava em 100%)
    const offset = circumference - (cleanPercentageForDrawing / 100) * circumference;

    return (
        <div className="relative flex items-center justify-center" style={{ width: size, height: size }}>
            {/* SVG Container */}
            <svg
                width={size}
                height={size}
                viewBox={`0 0 ${size} ${size}`}
                className="-rotate-90 transform"
            >
                {/* Círculo de Fundo (cinza) */}
                <circle
                    className="text-gray-200 dark:text-gray-700"
                    stroke="currentColor"
                    strokeWidth={strokeWidth}
                    fill="transparent"
                    r={radius}
                    cx={center}
                    cy={center}
                />
                
                {/* Círculo de Progresso (colorido) */}
                <circle
                    className={`transition-all duration-500 ease-out ${colorClass}`} // Recebe a cor (azul ou verde)
                    stroke="currentColor"
                    strokeWidth={strokeWidth}
                    fill="transparent"
                    r={radius}
                    cx={center}
                    cy={center}
                    strokeDasharray={circumference}
                    strokeDashoffset={offset} // Usa o offset travado em 100%
                    strokeLinecap="round"
                />
            </svg>

            {/* Texto da Porcentagem no Centro */}
            <div className="absolute flex items-center justify-center inset-0">
                <span className="text-xl font-bold text-gray-800 dark:text-gray-200">
                    {/* Exibe a porcentagem REAL (ex: 110.50%), com duas casas decimais */}
                    {(percentage || 0).toFixed(2)}%
                </span>
            </div>
        </div>
    );
};